import { Component, OnInit, ViewChild, ElementRef, Input, TemplateRef, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { ApiService } from '@services/api/api.service';
import { Router } from '../../../../../node_modules/@angular/router';
import { IGridOptions, IColumnOptions, IDataEndPoint, IFieldOptions, IEntityOptions, IFormOptions } from '@framework/interfaces/IEntity';
import { FormBuilderControl } from '../../../common/formbuilder/FormBuilderControl';
import { FormBuilderControlType } from '../../../common/formbuilder/FormBuilderControlType';
import { ViewType, FieldType, ActionType } from '../../core/Enums';
import { IButtonAction } from '../mf-blade/mf-blade.component';
import { MfFiltersComponent } from '../mf-filters/mf-filters.component';
import { IdentityAuthService } from '../../../services/identity-auth/identity-auth.service';
import * as _ from 'underscore';
import { MfColumnSelectorComponent } from '../mf-column-selector/mf-column-selector.component';
import { IControlChangeEventArgs } from '../../../common/formbuilder/IControlChangeEventArgs';
import { SignalRService } from '@services/signalr/signal-rservice.service';
import { MfTableV2Component } from '../mf-table-v2/mf-table-v2.component';
import { BehaviorSubject, Subscription } from 'rxjs';
import { GroupDescriptor, DataResult, process, State, CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';
import { ToastrService } from 'ngx-toastr';
import { IEntityModelField, IEntityModel } from '../../interfaces/IEntityModel';
import { Permissions } from '../../../config/AppEnums';
import { ToolbarActionType, ToolbarActionsService } from '../../../services/toolbar-actions/toolbar-actions.service';
import { MatDialog } from '@angular/material/dialog';
import { IPermissionConfig } from '../../app';
import { SharedFiltersService } from '../../../services/shared-filters/shared-filters.service';
import { appSettings } from '../../../modules/shared/components/appSettings';
import { TdDialogService } from '@covalent/core/dialogs';
import { NestedNavigationService } from '../../../services/nested-navigation/nested-navigation.service';

@Component({
  selector: 'mf-list-page',
  templateUrl: './mf-list-page.component.html',
  //styleUrls: ['@framework/components/mf-list-page/mf-list-page.component.css']
})
export class ListPageComponent implements OnInit {
  @ViewChild('assetLazyTable', { static: true }) lazyTable: MfTableV2Component;
  @ViewChild('mfFilters', { static: true }) mfFilters: MfFiltersComponent;
  @ViewChild('test', { static: true }) testDiv: ElementRef<any>;
  @ViewChild('customHeaderComponentTarget', { read: ViewContainerRef, static: true }) public customHeaderComponentTarget: ViewContainerRef;
  /* Private */
  private _selectedItem: any;
  private _selectedColumns: any[];
  private _currentFilters: any[];
  private _entityId: any;
  private _menuHidden: boolean = false;
  public dialogRef: any;
  public searchPhrase: any;
  public _customHeaderComponentInstance: any;
  private get model(): IEntityModel {
    return this.list.model ? this.list.model : this.entityOptions && this.entityOptions.model ? this.entityOptions.model : <IEntityModel>{}
  };
  /* Protected */
  protected listEntityOptions: IEntityOptions;
  protected listGridOptions: IGridOptions;
  protected listDetailsRouteUrl: string;
  protected listSearchForm: any;
  protected listLoadOnlyOnEntityId: boolean;
  protected listShowFilterColOnTable: boolean;
  protected listCanAdd: boolean = true;
  protected listTableReadonly: boolean = false;
  protected listReloadTableOnNotificationReceived: boolean = false;
  protected listUsev1: boolean = false;
  /* Public getters and setters */
  public get entityOptions(): IEntityOptions { return this.listEntityOptions };
  public set entityOptions(entityOptions: IEntityOptions) { this.listEntityOptions = entityOptions };

  public get tableReadOnly() {
    if (this.listTableReadonly)
      return true;
    if (this.list.editPermissions) {
      if (!this.authService.hasAnyPermissionsArr(this.list.editPermissions))
        return true;
    }
    return false;
  }
  public currentRequest: Subscription;
  public currentCountRequest: Subscription;
  public processData: Function;
  public get onDataLoadProcess() { return this.list.onDataLoadProcess ? this.list.onDataLoadProcess : this.processData; }
  public get disableNavigation() { return this.list.disableNavigation; }
  public get autoExpandRows() { return this.list.autoExpandRows; }
  public get autoExpandDetailRows() { return this.list.autoExpandDetailRows; }
  public get rowGroupMetadataActions() { return this.list.rowGroupMetadataActions; }
  public get grandTotalField() { return this.list.grandTotalField; }
  public get groupingField() { return this.list.groupingField; }
  public get grandTotalFunc() { return this.list.grandTotalFunc; }
  public get groupingSubtotalCalcField() { return this.list.groupingSubtotalCalcField; }
  public get groupingSubtotalCalcFunc() { return this.list.groupingSubtotalCalcFunc; }
  public get header(): string { return this.list.displayName ? this.list.displayName : this.model.displayName.split("|")[1] };
  public get list(): IGridOptions { return this.listGridOptions ? this.listGridOptions : (this.entityOptions && this.entityOptions.grid ? this.entityOptions.grid : { name: "" }) };
  public get detailsRouteUrl(): string { return this.listDetailsRouteUrl };
  public get autoSizeColumns() { return this.list.autoSizeColumns }
  public get tableIsGrouped() { return this.list.tableIsGrouped; }
  public get globalSearchEnabled() { return this.list.globalSearchEnabled; }
  public get selectionByCheckbox() { return this.list.selectionByCheckbox; }


  public get showFilterCol() { return this.listShowFilterColOnTable };
  public get loadOnlyOnEntity() { return this.listLoadOnlyOnEntityId };
  public get customHeaderComponent(): any { return this.list.customHeaderComponent };
  private _selectByIdentifier = 'id';
  public get selectByIdentifier() {
    return this.list.rowIdentifier ? this.list.rowIdentifier : this._selectByIdentifier;
  }
  public get canAdd() {
    return this.listCanAdd && !this.formReadonly && (!this.list || (this.list && !this.list.disableAdd));
  }
  public get entityId() { return this._entityId };
  public set entityId(value) {
    var force = false;
    if (this._entityId != value)
      force = true;
    if (force)
      this.reset();
    this._entityId = value;
    if (this.entityOptions && this.entityOptions.onEntityIdChange)
      this.entityOptions.onEntityIdChange(this, value)
    if (value == "00000000-0000-0000-0000-000000000000") {
      this.items = new Array();
      return;
    }
    if (!this.entityOptions && !this.listGridOptions) return;
    if (this.list.endPoints && this.list.dataEndPoint && this.list.dataEndPoint == this.list.endPoints.paging) {
      this.lazyTable.reloadTable(force);
    }
    else {
      //if (force)
      this.loadItems(null, null);
    }
    if (force && this._customHeaderComponentInstance && this._customHeaderComponentInstance.load)
      this._customHeaderComponentInstance.load(this.entityId)
    if (force && this.entityOptions && this.entityOptions && this.entityOptions.grid && this.entityOptions.grid.onEntityIdChange)
      this.entityOptions.grid.onEntityIdChange(value, this);
  }
  public get selectedColumns() { return this._selectedColumns; }
  public set selectedColumns(value) {
    this._selectedColumns = value;
    //debugger;
    //value.forEach(f => { f = new FormBuilderControl().load(f) });
  }
  public get selectedItem() { return this._selectedItem; }
  public set selectedItem(value) {
    this._selectedItem = value;
    if (this.list.onListSelectedItemChange) {
      this.list.onListSelectedItemChange(value, this);
    }
    else {
      if (value && value[this.selectByIdentifier]) {
        if (this.parent) {
          this.parent.navigateFromSelectedFormId = this.toolbarActionsService.selectedFormId;
          this.parent.navigateFromSelectedNestedFormId = this.toolbarActionsService.selectedNestedFormId;
        }
        if (this.detailsRouteUrl)
          this.router.navigate([this.detailsRouteUrl + value[this.selectByIdentifier]]);
        if (this.parent && this.parent.navigateToIndex && !this.disableNavigation)
          this.parent.navigateToIndex(this.parent.detailComponents[this.listIndex].bladeIndexToNavigateTo ? this.parent.detailComponents[this.listIndex].bladeIndexToNavigateTo : this.parent.formIndex + 1, value[this.selectByIdentifier], this.parent.formIndex);
      }
    }

  }
  public get menuHidden() { return this._menuHidden; }
  public set menuHidden(val) {
    var wasHidden = false;
    if (!val && this._menuHidden) wasHidden = true;
    this._menuHidden = val;
    if (wasHidden) {
      this.loadEntity();
    }
  }
  public height: string = "100%";
  /* Public */
  public splitter: any;
  public initialized: boolean = false;
  public formFields: Array<FormBuilderControl>;
  public instance: any;
  public useV2: boolean = false;
  public formReadonly: boolean;
  public assetPopupVisible: boolean;
  public expandedRowKeys: any;
  public searchFormData: any = {};
  public rowGroupMetadata: any;
  public items: any;
  public parent: any;
  public loading: boolean = false;
  public hidden: boolean = false;
  public staticColumns: any[];
  public columns: any[];
  public advancedFilters: any[] = [];
  public filterActive: boolean = false;
  public listIndex; any;
  public formIndex: number;
  public columnPopupVisible: boolean = false;
  public advancedPopupVisible: boolean = false;
  public filterCount: number; public lookupValues: any;
  public showAdvancedFilters: boolean;
  public staticFilters: any;
  public grandTotal: any;
  public waitingAuth: boolean;
  public loadingData: Function;
  public buttonActions: Array<IButtonAction> = new Array();
  public afterInitObserver = new BehaviorSubject(null);
  /* Constructors */
  constructor(public apiService: ApiService, public router: Router,
    public messageService: ToastrService, public authService: IdentityAuthService,
    public dialogService: TdDialogService, public signalRService: SignalRService, public toolbarActionsService: ToolbarActionsService, public sharedFiltersService: SharedFiltersService,
    private componentFactoryResolver: ComponentFactoryResolver,

    public nestedNavigationService: NestedNavigationService) {
  }
  /* Private Methods */
  private async load() {
    let self: ListPageComponent = this;
    self.initialized = true;
    //if (!self.authService.AppConfigLoaded) {
    //  self.loading = true;
    //  return;
    //}
    await self.authService.ensureAppSettingsLoaded();
    self.instance = self;
    self.columns = _.filter(self.list.columns, el => { return self.authService.canViewField(self.list.name, el.field) && !el.exclude });

    self.columns.forEach(column => {
      self.authService.extendedSettings(self.list.name, column.field).forEach(s => {
        if (s.name.indexOf(".") == -1) column[s.name] = s.value ? s.value : null
        else {
          let obj = column,
            names = s.name.split("."),
            namesLength = names.length - 1;
          names.forEach((n, i) => { if (i < namesLength) obj = obj[n] ? obj[n] : obj[n] = {} });
          obj[names[namesLength]] = s.value ? s.value : null;
        }
      });
    });

    self.columns = _.filter(self.columns, c => {
      let col: IColumnOptions = (<IColumnOptions>c);
      if (!col.permissions) return true;
      return col.permissions.filter(p => {
        let permissions: Array<IPermissionConfig> = new Array<IPermissionConfig>();
        permissions.push({ permissions: p.permissions });
        return self.authService.hasAnyPermissionsArr(permissions)
      }).length > 0;
    });
    self.setButtonActions();

    let searchFields: Array<IFieldOptions> = null,
      searchForm: IFormOptions = null;
    if (self.list.form && self.list.form.fields && self.list.form.fields.length > 0) {
      searchForm = self.list.form;
      searchFields = self.list.form.fields;
    }
    else if (self.entityOptions && self.entityOptions.form && self.entityOptions.form.fields && self.entityOptions.form.fields.length > 0) {
      searchForm = self.entityOptions.form;
      searchFields = self.entityOptions.form.fields.filter(f => f.search == true);
    }

    if (searchFields) {
      let searchFieldList = _.filter(searchFields, el => { return self.authService.canViewField(searchForm.name, el.field) });
      searchFieldList.forEach(field => {
        self.authService.extendedSettings(searchForm.name, field.field).forEach(s => {
          if (s.name.indexOf(".") == -1) field[s.name] = s.value ? s.value : null
          else {
            let obj = field,
              names = s.name.split("."),
              namesLength = names.length - 1;
            names.forEach((n, i) => { if (i < namesLength) obj = obj[n] ? obj[n] : obj[n] = {} });
            obj[names[namesLength]] = s.value ? s.value : null;
          }
        });
      });

      searchFieldList = _.filter(searchFields, f => {
        let field: IFieldOptions = (<IFieldOptions>f);
        if (!field.permissions) return true;
        return field.permissions.filter(p => {

          let permissions: Array<IPermissionConfig> = new Array<IPermissionConfig>();
          permissions.push({ permissions: p.permissions });
          return self.authService.hasAnyPermissionsArr(permissions)

        }).length > 0;
      })
      if (searchFieldList && searchFieldList.length > 0) self.formFields = self.getFormBuilderControls(searchForm, searchFieldList);
    }
    if (searchForm) searchForm.className = (searchForm.className ? searchForm.className + " " : "") + "col-xs-12 col-sm-12 col-md-12 col-lg-12"
    self.processColumns(self.columns, self.model.fields);
    var selectedColumns = new Array();
    self.columns.forEach(o => {
      selectedColumns.push(o);
    })
    self.staticColumns = self.columns;
    if (self.list.endPoints && self.list.dataEndPoint && self.list.dataEndPoint == self.list.endPoints.paging) {
      var newArr = new Array();
      if (self.model && self.model.nestedPrefix) {
        self.model.fields.forEach(f => {
          var exists = _.filter(self.columns, o => o.field == f.name);
          if (exists.length == 0)
            newArr.push({ field: f.name });
        })
        newArr.forEach(o => {
          self.columns.push(o);
        })
      }
      self.processColumns(self.columns, self.model ? self.model.fields : new Array<IEntityModelField>());
      if (self.list.relatedModels) {
        self.list.relatedModels.forEach(mod => {
          var arr = new Array();
          mod.fields.forEach(field => {
            arr.push({ field: field.name });
          });
          self.processColumns(arr, mod.fields);
          arr.forEach(o => {
            o.field = (mod.nestedPrefix ? mod.nestedPrefix : '') + (!mod.excludeModelPrefix ? (mod.name.substring(0, 1).toLowerCase() + mod.name.substring(1)).replace("Model", "") + '.' : '') + o.field;
            //if (!o.dbField)
            o.dbField = o.field.replace(".", "_");
            o.name = mod.name.replace("Model", "") + ' - ' + o.name;
            self.columns.push(o);
          });
        });
      }
    }

    self.selectedColumns = selectedColumns;
    self.staticFilters = new Array();
    if (self.list.staticFilters) {
      self.list.staticFilters.forEach(o => {
        self.staticFilters.push(o);
      });
      self.showAdvancedFilters = true;
    }
    if (self.parent && self.parent.entityIdChange) {
      self.entityId = self.parent.entityId;
      self.parent.entityIdChange.subscribe(entityId => {
        self.entityId = entityId;
      })
    }


    if (self.listReloadTableOnNotificationReceived) {
      self.signalRService.newNotification.subscribe(data => {
        self.lazyTable.reloadTable();
      })
    }
  }
  private processColumns(columns: Array<IColumnOptions>, fields: Array<IEntityModelField>) {
    this.lookupValues = new Array();
    this.lazyTable.defaultFilters.filters = [];
    columns.forEach(o => {
      if (o.default) {
        this.lazyTable.defaultFilters.filters.push({ operator: "eq", field: o.dbField, value: o.default })

        //if (!this.lazyTable.state.filter)
        //  this.lazyTable.state.filter = { logic: "and", filters: [{ operator: "eq", field: o.dbField, value: o.default }] };
        //else this.lazyTable.state.filter.filters.push({ operator: "eq", field: o.dbField, value: o.default });
        this.lazyTable.cdr.detectChanges();
        //this.lazyTable.filters[o.dbField] = o.default;
        //if (this.lazyTable.dt)
        //  this.lazyTable.dt.filters[o.dbField] = { value: o.default };
        //debugger;

        //this.state.filter.filters
      }
      if (fields[o.field]) {
        if (!o.name) o.name = fields[o.field].displayName;
        if (!o.fieldType) o.fieldType = fields[o.field].fieldType;
      }
      if (typeof o.readOnly === "undefined") o.readOnly = true;
      if (!o.filterMatchMode) o.filterMatchMode = 'contains';
      if (!o.dbField) o.dbField = o.field;

      if (o.dataEndPoint && o.dataEndPoint.url) {

        let url: string = {}.toString.call(o.dataEndPoint.url) === '[object Function]' ? o.dataEndPoint.url(o, self) : o.dataEndPoint.url;
        if (url)
          this.apiService.get(url).subscribe(items => {
            this.lookupValues.push({
              field: o.field,
              values: items.map(lo => {
                return { id: lo[o.dataIdField], display: lo[o.dataDisplayField] }
              }),
              processed: false
            })
            this.processLookupValues();
          }
          )
      }
      if (o.fieldType == FieldType.Enum) {
        o.lookups = this.model.enums[o.field].values.map(o => { return { value: o.value, label: o.display } });
        this.lookupValues.push({
          field: o.field,
          values: o.lookups,
          processed: false
        })
        this.processLookupValues();
      }

      if (!o.formBuilderControl) {

        let control = new FormBuilderControl();
        control.controlType = new FormBuilderControlType(typeof o.fieldType != 'undefined' ? o.fieldType : o.fieldType, null);

        if (o.viewType) {
          control.controlType.viewType = o.viewType;
        }

        control.displayName = o.name;
        control.bindingValue = o.field;
        control.field = o.field;
        control.fieldOptions = o;
        o.formBuilderControl = control;
      }
      else {
        if (!o.formBuilderControl.fieldOptions) {
          o.formBuilderControl.fieldOptions = o
        }
      }

      if (o.formBuilderControl.controlType.viewType == ViewType.CheckBox) o.filterMatchMode = 'equals';
      o.whereFilterType = 1;
    })


  }
  private getFormBuilderControls(form: IFormOptions, entityModelFields: Array<IFieldOptions>): Array<FormBuilderControl> {
    return entityModelFields.map(item => {
      let control = new FormBuilderControl();

      let itemDTO: IEntityModel = form.model ? form.model : this.entityOptions && this.entityOptions.model ? this.entityOptions.model : null;
      let itemDTOField: IEntityModelField = form.model && form.model.fields && form.model.fields[item.field] ? form.model.fields[item.field] : this.entityOptions && this.entityOptions.model ? this.entityOptions.model.fields[item.field] : null;
      control.controlType = new FormBuilderControlType(typeof item.fieldType != 'undefined' ? item.fieldType : (itemDTOField && typeof itemDTOField.fieldType != 'undefined') ? itemDTOField.fieldType : FieldType.Label, null);

      control.displayName = item.name ? item.name : itemDTOField && itemDTOField.displayName ? itemDTOField.displayName : itemDTOField && itemDTOField.name ? itemDTOField.name : item.field;
      control.bindingValue = item.field;
      control.field = item.field;
      control.customControl = item.customControl;
      control.show = function (scope, auth, instance) {
        if (item.show) return item.show(scope, auth, instance);
        return true;
      };

      if (item.viewType) control.controlType.viewType = item.viewType;
      if (item.fieldType ? item.fieldType == FieldType.Enum : itemDTOField ? itemDTOField.fieldType == FieldType.Enum : false) item.lookups = itemDTO ? itemDTO.enums[item.field].values.map(o => { return { value: o.value, label: o.display } }) : null;
      if (item.lookups) control.lookups = item.lookups;

      control.fieldOptions = item;

      return control;
    });
  }
  /* Public Methods */
  public reset() {
    this.items = new Array();
    this.formReadonly = false;
    this._menuHidden = false;
    this.lazyTable.currentFilterObject = null;
  }
  public loadEntity(force?: boolean, entityId?: any) {
    //if (entityId) {
    //  if (!this.selectedItem || this.selectedItem.id != entityId)
    //    this.selectedItem = { id: entityId };
    //}
    if (this.menuHidden) return;
    if (!this.entityOptions && !this.listGridOptions) return;
    if (this.list.endPoints && this.list.dataEndPoint && this.list.dataEndPoint == this.list.endPoints.paging) {
      this.lazyTable.reloadTable(force);
    }
    else {
      this.loadItems(null, null);
    }
    if (force && this._customHeaderComponentInstance && this._customHeaderComponentInstance.load)
      this._customHeaderComponentInstance.load(this.entityId)
  }
  public setButtonActions() {
    var self = this;
    this.buttonActions = new Array();
    if (this.canAdd) this.buttonActions.push({
      tooltip: 'Add new', click: function () {
        self.addNew()
      }, iconClass: 'nb-plus', text: "Add new",
      hidden: self.canAdd
    });
    if (!this.entityOptions && !this.listGridOptions) return;
    if (this.list.endPoints && self.list.dataEndPoint && self.list.dataEndPoint == this.list.endPoints.paging) {
      this.buttonActions.push({
        dropdownGroup: 'Advanced',

        text: 'Advanced column selection', click: function () {
          //self.columnPopupVisible = !self.columnPopupVisible;
          self.showColumnSelectionDialog();
        }, iconClass: 'nb-gear'
      });
      this.buttonActions.push({
        dropdownGroup: 'Advanced',
        disabled: function () { return true; },
        text: 'Advanced filters', click: function () {
          //self.mfFilters.advancedPopupVisible = !self.mfFilters.advancedPopupVisible;
          self.showAdvancedFiltersDialog();
        }, iconClass: 'pi pi-filter'
      });



    }
    if (this.parent && this.parent.setButtonActions) this.parent.setButtonActions();
  }
  //public resize() {
  //  if (this.lazyTable)
  //    this.lazyTable.resize();
  //}
  public groupingFunction: Function = function () {
    var rowGroupMetadata = {};
    if (this.items) {
      if (!this._dataSortedByGroup)
        this.items.data = _.sortBy(this.items.data, this.groupingField);
      else this._sortDataByGroup = this.items.data;
      this.items.data.forEach(o => {
        if (!o[this.groupingField])
          o[this.groupingField] = 'Empty';

        this.expandedRowKeys = {};

      })
      for (let i = 0; i < this.items.data.length; i++) {
        let rowData = this.items.data[i];
        let brand = rowData[this.groupingField];
        if (i == 0) {
          rowGroupMetadata[brand] = { index: 0, size: 1, rowTotal: 0 };
          if (this.groupingSubtotalCalcField && rowData[this.groupingSubtotalCalcField])
            rowGroupMetadata[brand].rowTotal = rowData[this.groupingSubtotalCalcField];
        }
        else {
          let previousRowData = this.items.data[i - 1];
          let previousRowGroup = previousRowData[this.groupingField];
          if (brand === previousRowGroup) {
            rowGroupMetadata[brand].size++;
            if (this.groupingSubtotalCalcField && rowData[this.groupingSubtotalCalcField])
              rowGroupMetadata[brand].rowTotal += rowData[this.groupingSubtotalCalcField];
          }
          else {
            rowGroupMetadata[brand] = { index: i, size: 1, groupTotal: 0 };
            if (this.groupingSubtotalCalcField && rowData[this.groupingSubtotalCalcField])
              rowGroupMetadata[brand].rowTotal = rowData[this.groupingSubtotalCalcField];
          }
        }
      }
    }

    if (this.autoExpandRows) {
      for (var i in rowGroupMetadata) {
        if (rowGroupMetadata.hasOwnProperty(i)) {
          //this.expandedRowKeys[i] = true //for new version
          this.expandedRowKeys[i] = 1 //old version
        }
      }
    }

    return rowGroupMetadata;
  }
  public advancedFilterSearch() {
    this.advancedFilters.forEach(item => {
      this.lazyTable.dt.filter(item.filter, item.field.filterName, 'contains');
    })
  }
  public clearAdvancedFilter() {
    this.advancedFilters = [];
    this.lazyTable.dt.reset();

  }
  public addNew() {
    debugger;
    if (!this.listCanAdd) {
      this.messageService.info('You do not have access to create an NCR')
      return;
    }
    if (this.list && this.list.onAddNewClick) {
      this.list.onAddNewClick(this);
    }
    else {
      if (this.parent && this.parent.navigateToIndex)
        this.parent.navigateToIndex(this.parent.detailComponents[this.listIndex].bladeIndexToNavigateTo ? this.parent.detailComponents[this.listIndex].bladeIndexToNavigateTo : this.parent.formIndex + 1,
          "00000000-0000-0000-0000-000000000000", this.parent.formIndex);
    }
  }
  public makeFormReadOnly(readonly) {
    this.formReadonly = readonly;
    this.setButtonActions();
  }
  public calcGrandTotal() {
    // Normalize items to array format - handle both DataResult (with .data property) and plain array
    var itemsArray = Array.isArray(this.items) ? this.items : (this.items && this.items.data ? this.items.data : []);
    
    if (this.grandTotalFunc) {
      this.grandTotal = this.grandTotalFunc(itemsArray);
      return;
    }

    if (!this.grandTotalField) {
      this.grandTotal = undefined;
      return;
    }
    var total = 0;
    itemsArray.forEach(o => {
      if (o[this.grandTotalField])
        total += o[this.grandTotalField]
    });
    this.grandTotal = 'Grand Total: ' + appSettings.currentCurrency.symbol + total.toLocaleString('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  public showColumnSelectionDialog() {
    const ref = this.dialogService.open(MfColumnSelectorComponent, {
      data: {
        staticColumns: this.staticColumns,
        loading: this.loading,
        columns: this.columns,
        selectedColumns: this.selectedColumns
      },
      //header: 'Select columns',
      width: '50%'
    });
    ref.afterClosed().subscribe((selectedColumns) => {
      if (selectedColumns) {
        this.selectedColumns = selectedColumns;
        setTimeout(() => {
          this.lazyTable.reloadTable(true);
        }, 1)
      }
    });
  }

  public customDetailRowTemplate: TemplateRef<any>;

  public showAdvancedFiltersDialog() {
    var self = this;
    const ref = this.dialogService.open(MfFiltersComponent, {
      data: {
        filters: self.staticFilters,
        columns: self.columns,
        showAdvancedFilters: self.showAdvancedFilters
      },
      //header: 'Advanced filters',
      width: '50%'
    });
    ref.afterClosed().subscribe((staticFilters) => {
      if (staticFilters) {
        this.staticFilters = staticFilters;
        this.lazyTable.reloadTable();
      }
    });
  }
  public setData(data, selectedItem) {
    var self = this;
    self.resetLookupValueProcessed();
    if (false) {//self.tableIsGrouped) {
      // self.lazyTable.state.group = self.lazyTable.groups
      // self.items = process(data, self.lazyTable.state);
    }
    else
      if (self.list && self.list.onLazyLoadProcessData) {
        self.list.onLazyLoadProcessData(data, self);
      } else self.items = data;
    if (selectedItem && self.selectedItem != selectedItem) self.selectedItem = selectedItem;
    self.loading = false;
    self.processLookupValues();
    if (self.tableIsGrouped)
      self.rowGroupMetadata = self.groupingFunction(self.items);
    if (self.parent.buildMenus)
      self.parent.buildMenus(self.items, false, self.listIndex, self)
    self.calcGrandTotal();

    if (self.loadingData)
      self.loadingData(false, self.items)


  }

  async loadItems(filterObject, selectedItem?) {
    if (!this.initialized)
      return;
    if (this.list.beforeLoad) {
      this.loading = true;
      await this.list.beforeLoad(this);
    }
    if (this.menuHidden)
      return;
    if (this.entityOptions) {
      if ((this.entityOptions.loadOnlyOnEntity || this.loadOnlyOnEntity) && !this.entityId)
        return;
    }
    else
      if ((typeof this.loadOnlyOnEntity == 'undefined' || this.loadOnlyOnEntity) && !this.entityId)
        return;

    let self: ListPageComponent = this;
    if (!self.entityOptions && !self.listGridOptions) return;
    if (self.list.endPoints && self.list.dataEndPoint && self.list.dataEndPoint == self.list.endPoints.paging) {
      this.loading = true;
      if (self.loadingData)
        self.loadingData(true, null)
      this.currentRequest = await self.apiService.exec({
        data: filterObject,
        endPoint: self.list.endPoints.paging,
        context: self,
        success: async function (data) {
          self.setData(data, selectedItem);
          if (self.list.endPoints.pagingTotalCount)
            this.currentCountRequest = await self.apiService.exec({
              data: filterObject,
              endPoint: self.list.endPoints.pagingTotalCount,
              context: self,
              success: function (data) {
                self.filterCount = data;
              },
              error: function (error) {
              }
            }, this.currentCountRequest)
          else self.filterCount = data.length;

          self.loading = false;

        },
        error: function (error) {
          self.loading = false;
          self.messageService.error('Could not load page filter', 'Action');
          if (self.loadingData)
            self.loadingData(false, null)
          self.loading = false;
        }
      }, this.currentRequest)

    }
    else if (self.list.dataEndPoint) {
      self.loading = true;
      if (this.loadingData)
        this.loadingData(true, null)
      this.currentRequest = await self.apiService.exec({
        endPoint: self.list.dataEndPoint,
        context: self,
        success: function (data) {
          self.resetLookupValueProcessed();
          if (self.onDataLoadProcess)
            data = self.onDataLoadProcess(self, data);

          if (self.tableIsGrouped) {
            self.lazyTable.state.group = self.lazyTable.groups;
            self.lazyTable.state.take = 99999
            // self.lazyTable.gridView = process(data, self.lazyTable.state);
          }
          self.items = data;
          if (selectedItem) self.selectedItem = selectedItem; self.loading = false;
          self.filterCount = self.items.length;
          self.processLookupValues();
          //if (self.tableIsGrouped)
          //self.rowGroupMetadata = self.groupingFunction(self.items);
          
          self.calcGrandTotal();

          if (self.loadingData)
            self.loadingData(false, self.items)
        },
        error: function (error) {
          self.loading = false;
          self.messageService.error('Could not load', 'Action');
          if (self.loadingData)
            self.loadingData(false, null)
        }
      }, this.currentRequest)
    }
  }
  resetLookupValueProcessed() {
    if (this.lookupValues)
      this.lookupValues.forEach(o => {
        o.processed = false;
      });
  }
  processLookupValues() {
    var self = this;
    if (self.lookupValues && self.items && self.items.length > 0) {
      self.lookupValues.filter(o => !o.processed).forEach(lo => {
        self.items.forEach(i => {
          var lookup = lo.values.filter(z => z.id == i[lo.field]);
          if (lookup.length > 0) i[lo.field] = lookup[0].display;
        });
        lo.processed = true;
      })
    }
  }
  search() {
    this.lazyTable.defaultFilters.filters.splice(0);
    Object.keys(this.searchFormData).forEach(o => {
      if (this.searchFormData[o] && this.searchFormData[o] != '')
        this.lazyTable.defaultFilters.filters.push({ operator: "eq", field: o, value: this.searchFormData[o] })
    })
    this.lazyTable.reloadTable();
  }
  clearSearchData() {
    this.searchFormData = {};
  }

  public actionType = ToolbarActionType;
  /* Public Events */
  public async ngOnInit() {
    //if (this.authService.AppConfigLoaded) {
    //  this.load();
    //}
    //else {
    if (this.list && this.list.onInit)
      await this.list.onInit(this);
    this.load();
    var self = this;
    var insertAdded = false;
    if (self.list && self.list.toolbar && self.list.toolbar.actions) {
      self.list.toolbar.actions.forEach(t => {
        if (t.type == ActionType.Insert) {
          var hasPermission = true;
          if (t.permissions && t.permissions.length > 0) {
            if (!self.authService.hasAnyPermissionsArr(t.permissions))
              hasPermission = false;
          }
          if (hasPermission)
            self.toolbarActionsService.addItem({ formId: self.parent.formIndex, nestedFormId: self.listIndex, command: function () { self.addNew() }, icon: "add", label: self.list && self.list.addNewText ? self.list.addNewText : 'Add', type: ToolbarActionType.Button, identifier: "add", sortOrder: 1 });
          insertAdded = true;
        }
      });
    }
    if (self.list && self.list.actions && self.list.actions) {
      self.list.actions.forEach(t => {
        if (t.type == ActionType.Custom) {
          t.custom.actions.forEach(i => {
            if (i.formButton)
              self.toolbarActionsService.addItem({ label: i.formButton.displayName, formId: self.parent.formIndex, nestedFormId: self.listIndex, command: function () { i.formButton?.action ? i.formButton?.action(self) : i.action(self) }, icon: i.formButton?.icon ?? i.icon, identifier: "cols", sortOrder: 2, type: ToolbarActionType.Button })
          })
        }
      });
    }
    if (self.canAdd && !insertAdded) {
      if (!self.list.addPermissions || (self.list.addPermissions && this.authService.hasAnyPermissionsArr(this.list.addPermissions)))
        //if (!self.list.canAddCalc || self.list.canAddCalc(self))
        self.toolbarActionsService.addItem({ formId: self.parent.formIndex, nestedFormId: self.listIndex, command: function () { self.addNew() }, tooltip: "Add new " + this.entityOptions.model.displayName.split("|")[0], icon: "add", label: self.list && self.list.addNewText ? self.list.addNewText : 'Add', type: ToolbarActionType.Button, identifier: "add", sortOrder: 1 })
    }

    if (this.list.endPoints && self.list.dataEndPoint && self.list.dataEndPoint == this.list.endPoints.paging) {
      self.toolbarActionsService.addItem({ dropdownGroup: "Advanced", formId: self.parent.formIndex, nestedFormId: self.listIndex, command: function () { self.showColumnSelectionDialog() }, label: 'Visible Columns', icon: "list", type: ToolbarActionType.IconButton, identifier: "cols", sortOrder: 2 })
      //self.toolbarActionsService.addItem({ dropdownGroup: "Advanced", formId: self.parent.formIndex, nestedFormId: self.listIndex, command: function () { self.showAdvancedFiltersDialog() }, disabled: true, label: 'Advanced Filter', icon: "filter_list", type: ToolbarActionType.IconButton, identifier: "filter", sortOrder: 3 })
    }

    if (this.list.endPoints.exportToExcel) {
      self.toolbarActionsService.addItem({
        dropdownGroup: "Advanced", formId: self.parent.formIndex, nestedFormId: self.listIndex,
        command: function () {
          var table = self.lazyTable;
          let filterArr = new Array();


          if (table.staticFilters)
            table.staticFilters.filter(function (o) {
              return o.filterValue != '' && o.filterValue != null
            })
              .forEach(o => {
                filterArr.push({ columnName: o.columnName, filterValue: o.filterValue, whereFilterType: o.whereFilterType });
              });
          let filterObject = JSON.parse(table.currentFilterObject);
          filterObject.StartCount = 0;
          filterObject.PageSize = 9999999;
          filterObject.FriendlyCols = table.selectedVisibleColumns.map(o => ({ value: o.dbField, key: o.name }))

          filterArr.forEach(o => {
            filterObject.Filters.push(o);
          });

          var download: IDataEndPoint = self.list.endPoints.exportToExcel;


          self.loading = true;

          self.apiService.exec({
            data: filterObject,
            endPoint: download,
            context: this.list,
            success: function (data) {
              self.messageService.success('Export has started download', 'Action');
              self.loading = false;
              const link = document.createElement('a');
              link.href = `${appSettings.apiServiceAddress}/api/fileServe/report/${data.name}`;
              link.setAttribute('visibility', 'hidden');
              link.click();
            },
            error: function (error) {
              self.loading = false;
              self.messageService.error('Could not Export', 'Action');
            }
          })
        }, label: 'Export current selection to excel', icon: "file_download", type: ToolbarActionType.IconButton, identifier: "export", sortOrder: 4
      })
    }
  }
  public ngAfterViewInit() {
    setTimeout(_ => {
      if (this.customHeaderComponent) {
        let widgetComponent = this.componentFactoryResolver.resolveComponentFactory(this.customHeaderComponent);
        let componentRef: any = this.customHeaderComponentTarget.createComponent(widgetComponent);
        let _component: any = (componentRef.instance);
        _component.parent = this;
        this._customHeaderComponentInstance = _component;
        if (this.entityId)
          this._customHeaderComponentInstance.load(this.entityId)
      }
      //this.afterInitObserver.next(this.testDivHeight);
    }, 1);

  }
  public onControlDataChange(event: IControlChangeEventArgs) {

    let self = this;
    let col = _.filter(this.columns, o =>
      o.dbField == event.formBuilderControl.field
    )[0];
    if (self.formReadonly) {
      event.context.loading = false;
      event.context.data = !event.controlValue;
      event.context.cdr.detectChanges();
      self.messageService.error('Could not save', 'Permissions related');
      return;
    }
    if (col.endPoints) {
      if (event.formBuilderControl.controlType.viewType == ViewType.CheckBox) {
        let endPoint: IDataEndPoint = (col.endPoints.insert && event.controlValue) ? col.endPoints.insert : (col.endPoints.delete && !event.controlValue) ? col.endPoints.delete : null;
        event.context.loading = true;
        event.context.cdr.detectChanges();
        if (endPoint) {
          self.apiService.exec({
            endPoint: endPoint,
            data: event.extraData,
            context: self,
            success: function (data) {
              event.context.loading = false;
              event.context.cdr.detectChanges();
              if (self.parent && self.parent.onBladeSave)
                self.parent.onBladeSave(self);
              if (self.parent && self.parent.updateLists)
                self.parent.updateLists();
              if (self.entityOptions && self.entityOptions.onSaveComplete) self.entityOptions.onSaveComplete(self, data);
              if (self.entityOptions && self.entityOptions.grid && self.entityOptions.grid.onSaveComplete) self.entityOptions.grid.onSaveComplete(self, data);
            },
            error: function (error) {
              event.context.loading = false;
              event.context.data = !event.controlValue;
              event.context.cdr.detectChanges();
              self.messageService.error('Could not save', 'Action');
            }
          })
        }
      }

      if (event.formBuilderControl.controlType.viewType == ViewType.StatusChange) {
        let endPoint: IDataEndPoint = col.endPoints.update;
        if (endPoint) {
          self.loading = true;
          self.apiService.exec({
            endPoint: endPoint,
            data: event.extraData,
            context: self,
            success: function (data) {
              self.loading = false;
              self.messageService.success('Successfully saved', 'Action');
              if (self.parent && self.parent.onBladeSave)
                self.parent.onBladeSave(self);
              if (self.parent && self.parent.updateLists)
                self.parent.updateLists();
            },
            error: function (error) {
              self.loading = false;
              self.messageService.error('Could not save', 'Action');
            }
          })
        }
      }
    }
  }
  onAdvancedFilterSearch(filters) {
    this.lazyTable.reloadTable();
  }
  onPageEvent() {
    this.splitter.nativeElement.scrollTo({ top: (0), behavior: 'smooth' });
  }

  public itemClick(item) {
    if (this.list.onItemClick) {
      this.list.onItemClick(item, this);
    }
  }
}
